import type { SVGProps } from 'react';

const TransferIcon = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M8.50001 6.17727L10.6667 3.84393M10.6667 3.84393L12.8333 6.17727M10.6667 3.84393V8.84393M12.8333 9.84393C12.8333 9.84393 11.5473 11.2373 10.9047 12.8439L9.83334 11.5579M7.50001 9.84393L5.33334 12.1773M5.33334 12.1773L3.16667 9.84393M5.33334 12.1773V3.84393"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TransferIcon;
